import 'client-only';

import { DEAL_PACKAGE_ROUTE_PROXY_SERVER_TIMING } from './constants';

export interface DealPackageNavigationTimings {
  queue_ms: number;
  ttfb_ms: number;
  download_ms: number;
  dom_interactive_ms: number;
  load_event_ms: number;
  proxy_server_timing_ms: number;
}

function parseProxyServerTimingMs(): number {
  const entries = performance.getEntriesByType(
    'navigation'
  ) as PerformanceNavigationTiming[];
  const nav = entries[0];
  if (!nav) return -1;

  // `serverTiming` is populated when the document response carried Server-Timing.
  const proxyEntry = nav.serverTiming?.find(
    entry => entry.name === DEAL_PACKAGE_ROUTE_PROXY_SERVER_TIMING
  );
  if (proxyEntry && Number.isFinite(proxyEntry.duration)) {
    return proxyEntry.duration;
  }
  return -1;
}

export function collectDealPackageNavigationTimings(): DealPackageNavigationTimings | null {
  if (typeof performance === 'undefined') return null;

  const entries = performance.getEntriesByType(
    'navigation'
  ) as PerformanceNavigationTiming[];
  const nav = entries[0];
  if (!nav || nav.responseStart <= 0) return null;

  const queue_ms = Math.max(0, nav.responseStart - nav.requestStart);
  const ttfb_ms = queue_ms;
  const download_ms = Math.max(0, nav.responseEnd - nav.responseStart);
  const dom_interactive_ms = Math.max(0, nav.domInteractive - nav.requestStart);
  const load_event_ms = Math.max(0, nav.loadEventEnd - nav.requestStart);
  const proxy_server_timing_ms = parseProxyServerTimingMs();

  return {
    queue_ms,
    ttfb_ms,
    download_ms,
    dom_interactive_ms,
    load_event_ms,
    proxy_server_timing_ms,
  };
}
